import barra from '../../general/barra/barra.vue'
import barrais from '../../general/barrais/barrais.vue'
import foot from '../../general/foot/foot.vue'
import barrade from '../../general/barrade/barrade.vue'
import mixx from "../../../mixin/mixin.js";

export default {
  mixins: [mixx],
  name: 'fiservArchivos',
  data() {
    return {
      loading: false,
      files:[],
      filter:""
    }
  },
  mounted: function () {
    $('#cont_r').css("min-height", (window.innerHeight - 101) + "px");
    $(".box").boxWidget();
    this.getListaArchivos();
  },
  methods: {
    getListaArchivos() {
      this.loading = true;
      this.$http
        .get('/config/fiserv/files')
        .then(response => {
          this.files=response.data
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  components: {
    barra,
    barrais,
    foot,
    barrade
  }
}



// WEBPACK FOOTER //
// ./src/components/configs/archivosFiserv/index.js